'use strict';

exports.__esModule = true;
var Colors = {
  vezeetaBlue: '#0070cd',
  vezeetaRed: '#ef0f0f',
  blueOne: '#3e8ddd',
  blueTwo: '#005cb8',
  searchGreyShade: '#333',
  defaultGrey: '#58595b',
  helperGrey: '#808184',
  mediumGrey: '#e0e0e0',
  lightGrey: '#f5f5f5',
  success: '#7cbb69',
  warning: '#ffd350'
};

exports.default = Colors;
module.exports = exports['default'];